<template>
  <b-container fluid>
    <b-modal id="selbstdeklarationMAmodal" v-if="gotoGT" :title="paketMooh.name[$i18n.locale]">
      <p style="white-space: normal;">{{ $t("ZuerstGruenerTeppichBearbeiten") }}</p>
      <!-- Möchten Sie im Anschluss «mooh Auslese» ausfüllen? -->
      <b-button v-on:click="closeGotoGruenerTeppich" variant="primary">{{ $t("WeiterZuGruenerTeppich") }}</b-button>
      <div slot="modal-footer">
        <b-button v-on:click="close" variant="secondary">{{ $t("close") }}</b-button>
      </div>
    </b-modal>
    <b-modal id="selbstdeklarationMAmodal" v-if="! gotoGT" :title="dialogTitle" size="xl">
      <div v-html="dialogText"></div>
      <b-container fluid v-if="dataLoaded">
        <!-- <div v-show="anforderungen(anforderungsNr).length">-->
        <div v-show="kriterienKatalog.length">
          <b-form v-on:submit.prevent="onSubmit" ref="gruppeX">
            <div
              v-for="kriterium in kriterienKatalog"
              v-bind:key="kriterium.id"
            >
              <selbstdeklaration-zeile
                :kriterium="kriterium"
                :disabled="kriterium.disabled"
                :state="kriterium.statefn"
              />
            </div>
          </b-form>
        </div>
      </b-container>

      <b-container fluid v-if="dataLoaded && showVerwerter">
        <div v-for="(verwerterX, indx) in verwerter" v-bind:key="indx">
          <b-form-checkbox
            class="col-10"
            v-model="paketGT.organisationen[indx].freigabe"
            :id="'verwerter' + verwerterX.orgid"
            :disabled="verwerterX.disabled"
            v-on:change="freigabeChanged(verwerterX.orgid, indx)"
          >
            {{ verwerterX.organisation }}
            <span v-if="verwerterX.von.length">({{ $t("Seit").toLowerCase() }} {{ convertTime(verwerterX.von) }})</span>
          </b-form-checkbox>
        </div>
        <!-- <h3 v-html="terms.title[$i18n.locale]"></h3>
        <p v-html="terms.text[$i18n.locale]"></p> -->
        <b-form-checkbox
          id="AGB"
          v-model="agb"
          name="agb"
          value="accepted"
          unchecked-value="not_accepted"
        >
          <span v-html="checkboxText"></span>
        </b-form-checkbox>
      </b-container>
      <div slot="modal-footer">
        <b-button
          v-on:click="close"
          v-if="wizardStep === 0"
          variant="secondary"
          >{{ $t("Abbrechen") }}</b-button
        > 
        <b-button
          v-on:click="close"
          v-if="showSaveDialog"
          variant="secondary"
          >{{ $t("close") }}</b-button
        > 
        <b-button
          v-on:click="back"
          v-if="wizardStep > 0 && !showSaveDialog"
          variant="secondary"
          >{{ $t("back") }}</b-button
        >
        &nbsp;
        <b-button
          type="button"
          v-if="showWeiterBtn"
          v-on:click="weiter"
          variant="primary"
          >{{ $t("Weiter") }}</b-button
        > 
        <b-button
          type="button"
          v-if="showSaveBtn"
          :disabled="agb === 'not_accepted'"
          v-on:click="save"
          variant="primary"
          >{{ $t("Speichern") }}</b-button
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import moment from "moment";
import { bus, i18n } from "../../main";
import SelbstdeklarationZeile from "./SelbstdeklarationZeile.vue";

export default {
  name: "Selbstdeklaration",
  data() {
    return {
      agb: "not_accepted",
      wizardStep: 0,
      paketId: 4 /* Mooh Auslese gemäss DB */,
      step: 0,
      saveStatus: "saving" /* saving, saved, error */,
      weiterBtValid: true,
      kriterienKatalog: [],
    };
  },
  computed: {
/*
    paketMoohArrRef() {
      return this.$store.state.datenpaketeStore.MA.arrayRef;
    },
*/
    dataLoaded() {
      return this.$store.state.datenpaketeStore.MA.arrayRef != null;
    },
    paketMooh() {
      return this.$store.state.datenpaketeStore.pakete[this.$store.state.datenpaketeStore.MA.arrayRef];
      //return this.$store.state.datenpaketeStore.pakete[this.paketMoohArrRef];
    },
    gotoGT() {
      if (this.$store.state.datenpaketeStore.GT.status === null) return false;
      return this.$store.state.datenpaketeStore.GT.status === 0;
    },
    gruppe() {
      // arrayindex der Gruppe == wizardstep solange die sortierung stimmt ..
      return this.wizardStep;
    },
    anforderungsNr() {
      return this.wizardStep + 1;
    },
    dialogTitle() {
      let title = "";
      if (this.gruppe < this.gruppenLength) {
        title = this.paketMooh.gruppen[this.gruppe].title[i18n.locale];
      } else if (this.showVerwerter) {
        title = this.paketMooh.approval.title[i18n.locale];
      } else if (this.showSaveDialog) {
        title = this.paketMooh.save.title[i18n.locale];
      }
      return title;
    },
    dialogText() {
      let text = "";
      if (this.gruppe < this.gruppenLength) {
        text = this.paketMooh.gruppen[this.gruppe].text[i18n.locale];
      } else if (this.showVerwerter) {
        text = this.paketMooh.terms.text[i18n.locale];
      } else if (this.showSaveDialog) {
        text = this.showSaveText;
      }
      return text;
    },
    checkboxText() {
      return this.paketMooh.terms.box[i18n.locale];
    },
    gruppenLength() {
      return this.paketMooh.gruppen.length
        ? this.paketMooh.gruppen.length
        : 1;
    },
    showWeiterBtn() {
      return this.wizardStep < this.gruppenLength ? true : false;
    },
    verwerter() {
      return this.paketMooh.organisationen;
    },
    showVerwerter() {
      return this.wizardStep === this.gruppenLength ? true : false;
    },
    showSaveBtn() {
      return this.showVerwerter ? true : false;
    },
    showSaveDialog() {
      return this.wizardStep === this.gruppenLength + 1 ? true : false;
    },
    showCloseBtn() {
      return this.wizardStep == 0 || this.showSaveDialog;
    },
    showSaveText() {
      switch (this.saveStatus) {
        case "saving":
          return this.paketMooh.save.text[this.$i18n.locale];
        case "saved":
          return this.paketMooh.save.ok[this.$i18n.locale];
        case "error":
          return this.paketMooh.save.nok[this.$i18n.locale];
        default:
          return "etwas ist schief gelaufen??";
      }
    },
  },
  methods: {
    async initModal() {
      this.wizardStep = 0;
      this.agb = "not_accepted";
      this.saveStatus = "saving";
      this.kriterienKatalog = this.anforderungen(this.anforderungsNr);
      bus.$emit('LebtagleistungManuell', this.paketMooh.kriterien.filter(krit => krit.key === "LebtagleistungManuell")[0].value);
    },
    scrollToTop() {
      this.$nextTick(async function() {
        //window.scrollTo(0,0); // scrollt das Hauptfenster im Hintergrund
        var element = document.getElementsByClassName("modal-title")[0];
        element.scrollIntoView(true);
        //element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      });
    },
    weiter() {
      let test = true;
      for (let krtX of this.kriterienKatalog) {
        krtX.showInitialState = false
        if (krtX.statefn(krtX) === false) {
          test = false;
        }
      }
      if (test) {//continue to the next wizardstep
        this.wizardStep++;
        this.kriterienKatalog = this.anforderungen(this.anforderungsNr);
        if (! this.paketMooh.status.datum.length)
          this.$store.dispatch("savePaket", { id: this.paketId, declaration: true, approval: false });
      }
      //this.weiterBtValid = this.calcWeiterBtn()
      this.scrollToTop();
    },
    back() {
      this.wizardStep--;
      this.kriterienKatalog = this.anforderungen(this.anforderungsNr);
      if (! this.paketMooh.status.datum.length)
        this.$store.dispatch("savePaket", { id: this.paketId, declaration: true, approval: false});
      //this.weiterBtValid = this.calcWeiterBtn()
      this.scrollToTop();
    },
    save() {
      this.wizardStep++;
      this.$store.dispatch("savePaket", { id: this.paketId, declaration: true, approval: true });
    },
    async saveInProgressDone(savedPaketID, errorMsg) {
      if (savedPaketID !== this.paketId) return;
      if (typeof errorMsg == "string" && errorMsg.length > 0) {
        this.saveStatus = "error";
      } else {
        this.saveStatus = "saved";
      }
    },
    close() {
      this.wizardStep = 0;
      this.$root.$emit("bv::hide::modal", "selbstdeklarationMAmodal");
    },
    evaluator(expression) {
      try {
        return new Function("return " + expression)();
      } catch (e) {
        return -1;
      }
    },
    anforderungen(art) {
      let self = this;
      let kriterienkatalog = this.paketMooh.kriterien.filter(
        (kritX) => kritX.art === art
      );
      
      kriterienkatalog.map(function(krtX) {
        if (typeof krtX.expression == "string") {
          let pattern = /[a-zA-Z]+/gi;
          let keynamen = krtX.expression.match(pattern);
          if (keynamen && keynamen.length) {
            let replacedExpression = krtX.expression;
            for (let keynameX of keynamen) {
              let zahl = null;
              try {
                zahl = self.paketMooh.kriterien.filter(
                  (krit) => krit.key === keynameX
                )[0].value;
              } catch (e) {
                alert("Key " + keynameX + " nicht gefunden!");
              }
              if (zahl === null) {
                //console.log('Kriterium:'+keynameX, 'wert:'+zahl)
                zahl = 0;
              }
              replacedExpression = replacedExpression.replace(
                keynameX,
                zahl.toString()
              );
            }
            //console.log("expression: "+krtX.expression+", replacedExpression: " + replacedExpression);

            try{
              krtX.value = Number.parseFloat(
              self.evaluator(replacedExpression)
            ).toFixed(2);
            }catch(e){
              //nulldivision
              return null
            }
          }
        }
      });
      return kriterienkatalog;
    },
    convertTime(value) {
      return moment(value).format("DD.MM.YYYY");
    },
    calcWeiterBtn() {
      // keine Nullwerte AND alle Felder valid
      let test = true;
      for (const krtX of this.kriterienKatalog) {
        if (krtX.statefn(krtX) === null || krtX.statefn(krtX) === false) {
          test = false;
          break;
        }
      }
      this.weiterBtValid = test;
      return test;
    },
    closeGotoGruenerTeppich() {
      //this.close() //schliesst den GT
      this.$root.$emit("bv::hide::modal", "selbstdeklarationMAmodal");
      this.$root.$emit("bv::show::modal", "selbstdeklarationGTmodal", 2);
    },
  },
  components: {
    "selbstdeklaration-zeile": SelbstdeklarationZeile,
  },
  created() {},
  mounted() {
    let self = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "selbstdeklarationMAmodal") {
        this.initModal();
      }
    });
    bus.$on("paketSaved", self.saveInProgressDone);
  },
  updated() {},
  watch: {
    kriterienKatalog: {
      handler: function () { 
        this.anforderungen(this.anforderungsNr)
        this.calcWeiterBtn()
        }, 
      deep: true,
    },
  },
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>